export enum EditInventoryMode {
  AllSizes = 'all-sizes',
  Single = 'single',
}
